import GenericTabComponent from "../../components/GenericTabComponent";
import MatchFixtures from "./Tabs/MatchFixtures";

export default function SeniorNationalRugby7s() {
  const content = [
    { label: "Match Fixtures", component: <MatchFixtures /> },
  ];

  return (
    <GenericTabComponent
      content={content}
      desktopBanner="/img/sen-nat-rug-7-banner.jpeg"
      mobileBanner="/img/sen-nat-rug-7-mobile.png"
      pageTitle="Senior National Rugby Sevens Championships 2026"
    />
  );
}
